import { render, staticRenderFns } from "./UserInformPanel.vue?vue&type=template&id=2aae4caa&"
import script from "./UserInformPanel.vue?vue&type=script&lang=ts&"
export * from "./UserInformPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports